// Handle out of stock message for color swatches
document.addEventListener("DOMContentLoaded", function () {
  const swatchInputs = document.querySelectorAll(
    '.f-swatch__list input[type="radio"]'
  );

  swatchInputs.forEach((input) => {
    input.addEventListener("change", function () {
      updateOutOfStockMessage(this);
    });

    // Check initial state
    if (input.checked) {
      updateOutOfStockMessage(input);
    }
  });

  function updateOutOfStockMessage(input) {
    const optionTitle = input
      .closest(".wt-product__option")
      .querySelector(".wt-product__option__title");
    const valueElement = optionTitle.querySelector(".value");

    // Remove existing out of stock message
    const existingMessage = optionTitle.querySelector(".out-of-stock-message");
    if (existingMessage) {
      existingMessage.remove();
    }

    // Update the value text
    valueElement.textContent = input.value;

    // Add out of stock message if the input is disabled
    if (input.classList.contains("disabled")) {
      const outOfStockSpan = document.createElement("span");
      outOfStockSpan.className = "out-of-stock-message";
      outOfStockSpan.textContent = "COMING SOON";
      optionTitle.appendChild(outOfStockSpan);
    }
  }
});
